const noscrollOffset = (el) => {
  const vw = window.innerWidth;
  let yOffset;
  if (vw <= 560) {
    yOffset = -80;
  } else if (vw <= 800) {
    yOffset = -96;
  } else if (vw <= 1024) {
    yOffset = -104;
  } else if (vw <= 1440) {
    yOffset = -136;
  } else {
    yOffset = -156;
  }

  const y = el.getBoundingClientRect().top + window.scrollY + yOffset;
  window.scrollTo({ top: y });
};
export default noscrollOffset;
